import TenantInfoContainer from 'components/feature/tenant/info/TenantInfoContainer';

const TenantInfoPage = () => {
  return <TenantInfoContainer />;
};

export default TenantInfoPage;
